import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

export function useIsInHomeEnabled() {
  const worker = useDefinedWorker();
  return worker.homeHealthEnabled ?? false;
}
